import React from "react";

export const Moemdm = () => {

  return (
    <div className="mb-16">
      <div className="flex items-center staticBanner bg-[#cbbef0] relative">
        <div className="staticBannerContent">
          <img
            src="/images/infoBanner.png"
            alt="banner"
            className="staticBannerImg"
          />
          <div className="text-base sm:text-lg md:text-3xl absolute w-[40%] max-w-[400px] translate-x-[59%] max-h-full overflow-auto">
            <h2 className="font-black text-primaryDark">MOEMDM</h2>
            {/* <p className="text-secondaryDark mt-[0.5em] text-[0.65em] leading-normal">
                參加高雄市數位研習活動，掌握最新教學科技，提升教學智慧，讓學生學習效果更卓越！這裡專門提供教師的研習資訊，助您持續進步。
              </p> */}
          </div>
        </div>
      </div>
      <div className="staticSection !pb-0">
        <div className="sectionContent">
          <div className="border-2 border-headline relative text-base sm:text-2xl">
            <div className="flex justify-center items-center font-bold absolute left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white px-2 text-Headline text-nowrap">
              <span className="text-[0.55em]">〇〇〇</span>
              <h3 className="px-1">MOEMDM</h3>
              <span className="text-[0.55em]">〇〇〇</span>
            </div>

            <div className="flex flex-col sm:flex-row justify-center gpa-12 py-8">
              <div className="px-4 py-4 sm:px-12 sm:py-16 flex justify-center md:gap-10 text-center text-[0.9em]">
                <a
                  href="https://drive.google.com/drive/folders/1XMFOzV9kfjPNif7FWis4of1xQBcLhKGQ?usp=sharing"
                  target="_blank"
                  rel="noopener noreferrer"
                  className=""
                >
                  <button className="roundedAnimationBtn bg-secondary text-white  flex-1">
                    <div className="p-2 sm:p-4 bg-white w-1/4 h-full">
                      <img
                        src="/images/info.svg"
                        alt=""
                        className="w-32 h-full object-contain object-center"
                      />
                    </div>
                    <div className="grow ">新手教學</div>
                  </button>
                </a>
              </div>

              <div className="px-4 py-4 sm:px-12 sm:py-16 flex justify-center md:gap-10 text-center text-[0.9em]">
                <a
                  href="https://mdm.edu.tw/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className=""
                >
                  <button className="roundedAnimationBtn bg-primary text-white  flex-1">
                    <div className="p-2 sm:p-4 bg-white w-1/4 h-full">
                      <img
                        src="/images/search.svg"
                        alt=""
                        className="w-32 h-full object-contain object-center"
                      />
                    </div>
                    <div className="grow ">進入查詢</div>
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};
